/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DomeggookSkuVo } from './DomeggookSkuVo';
import {
    DomeggookSkuVoFromJSON,
    DomeggookSkuVoFromJSONTyped,
    DomeggookSkuVoToJSON,
    DomeggookSkuVoToJSONTyped,
} from './DomeggookSkuVo';

/**
 * 
 * @export
 * @interface DomeggookGoodsVo
 */
export interface DomeggookGoodsVo {
    /**
     * 
     * @type {string}
     * @memberof DomeggookGoodsVo
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof DomeggookGoodsVo
     */
    picUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof DomeggookGoodsVo
     */
    shopSite?: string;
    /**
     * 
     * @type {Array<DomeggookSkuVo>}
     * @memberof DomeggookGoodsVo
     */
    skus?: Array<DomeggookSkuVo>;
}

/**
 * Check if a given object implements the DomeggookGoodsVo interface.
 */
export function instanceOfDomeggookGoodsVo(value: object): value is DomeggookGoodsVo {
    return true;
}

export function DomeggookGoodsVoFromJSON(json: any): DomeggookGoodsVo {
    return DomeggookGoodsVoFromJSONTyped(json, false);
}

export function DomeggookGoodsVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): DomeggookGoodsVo {
    if (json == null) {
        return json;
    }
    return {
        
        'title': json['title'] == null ? undefined : json['title'],
        'picUrl': json['picUrl'] == null ? undefined : json['picUrl'],
        'shopSite': json['shopSite'] == null ? undefined : json['shopSite'],
        'skus': json['skus'] == null ? undefined : ((json['skus'] as Array<any>).map(DomeggookSkuVoFromJSON)),
    };
}

export function DomeggookGoodsVoToJSON(json: any): DomeggookGoodsVo {
    return DomeggookGoodsVoToJSONTyped(json, false);
}

export function DomeggookGoodsVoToJSONTyped(value?: DomeggookGoodsVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'title': value['title'],
        'picUrl': value['picUrl'],
        'shopSite': value['shopSite'],
        'skus': value['skus'] == null ? undefined : ((value['skus'] as Array<any>).map(DomeggookSkuVoToJSON)),
    };
}

